import type { PropsWithChildren } from 'react';
import { I18nProvider } from '@heroui/react';

export function HeroUiProvider({ children }: PropsWithChildren) {
  return <I18nProvider locale="en-US">{children}</I18nProvider>;
}
